(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bk-anchor-nav')) {
    class BkAnchorNav extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('.bkan__btn')];
        this.extra = parseInt(this.dataset.offset, 10) || 0;
        this.onClick = this.onClick.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.links.forEach((a) => a.addEventListener('click', this.onClick));
        if (this.dataset.sticky === 'true') this.updateStickyTop();
        if (this.dataset.highlight === 'true') {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }
        if (window.Shopify && window.Shopify.designMode) this.markMissing();
        this.onResize = () => { if (this.dataset.sticky === 'true') this.updateStickyTop(); };
        window.addEventListener('resize', this.onResize, { passive: true });
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }
      target(a) {
        const id = a.dataset.target;
        return id ? document.getElementById(id) : null;
      }
      headerOffset() {
        const header = document.querySelector('header-component, #header-component, .header-section, header');
        if (!header) return 0;
        const pos = getComputedStyle(header.closest('.shopify-section') || header).position;
        if (pos !== 'sticky' && pos !== 'fixed') return 0;
        // Hoehe des fixierten Headers, nicht seine aktuelle Unterkante: ueber ihm
        // liegt beim Laden noch das Laufband, das beim Scrollen verschwindet.
        return header.getBoundingClientRect().height;
      }
      offset() {
        let o = this.headerOffset() + this.extra;
        if (this.dataset.sticky === 'true') o += this.getBoundingClientRect().height;
        return o;
      }
      updateStickyTop() {
        const wrap = this.closest('.shopify-section');
        if (wrap) wrap.style.setProperty('--bkan-sticky-top', this.headerOffset() + 'px');
      }
      onClick(e) {
        const el = this.target(e.currentTarget);
        if (!el) return;
        e.preventDefault();
        const top = el.getBoundingClientRect().top + window.scrollY - this.offset();
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
        history.replaceState(null, '', '#' + e.currentTarget.dataset.target);
      }
      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          const line = this.offset() + 8;
          let active = null;
          this.links.forEach((a) => {
            const el = this.target(a);
            if (el && el.getBoundingClientRect().top <= line) active = a;
          });
          this.links.forEach((a) => a.classList.toggle('is-active', a === active));
        });
      }
      markMissing() {
        this.links.forEach((a) => {
          if (!this.target(a)) {
            a.setAttribute('data-missing', '');
            a.title = 'Kein Ziel mit der ID "' + a.dataset.target + '" auf dieser Seite gefunden';
          }
        });
      }
    }
    customElements.define('bk-anchor-nav', BkAnchorNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bk-countdown')) {
    class BkCountdown extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.units = (d.units || 'Tage,Std.,Min.,Sek.').split(',').map((u) => u.trim());
        this.showDays = d.showDays !== 'false';
        this.showSeconds = d.showSeconds !== 'false';
        this.separator = d.separator === 'true';
        this.start = parseInt(d.start, 10) * 1000 || 0;
        this.timeEl = this.querySelector('[data-cd-time]');
        this.doneEl = this.querySelector('[data-cd-done]');
        this.tick = this.tick.bind(this);
        if (d.sticky === 'true') {
          // Header-Hoehe steht beim Laden oft noch nicht fest (Logo, Schriften),
          // daher neu messen, sobald sich der Header in der Groesse aendert.
          this.updateSticky = this.updateSticky.bind(this);
          this.updateSticky();
          const header = document.querySelector('header-component, #header-component, .header-section, header');
          if (header && window.ResizeObserver) {
            this.headerObserver = new ResizeObserver(this.updateSticky);
            this.headerObserver.observe(header);
          }
          window.addEventListener('load', this.updateSticky);
        }
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.headerObserver) this.headerObserver.disconnect();
      }
      updateSticky() {
        const header = document.querySelector('header-component, #header-component, .header-section, header');
        const wrap = this.closest('.shopify-section');
        if (!header || !wrap) return;
        const headerStyle = getComputedStyle(header.closest('.shopify-section') || header);
        const pos = headerStyle.position;
        // Header klebt bei top:-1px, deshalb dessen top-Wert mitrechnen, sonst bleibt 1px Luecke
        const h = pos === 'sticky' || pos === 'fixed' ? header.getBoundingClientRect().height + (parseFloat(headerStyle.top) || 0) : 0;
        wrap.style.setProperty('--bkcd-sticky-top', h + 'px');
      }
      // Zeitpunkt HH:MM heute in der Shop-Zeitzone, nach Ablauf morgen
      dailyEnd() {
        const [hh, mm] = (this.dataset.daily || '0:0').split(':').map((n) => parseInt(n, 10) || 0);
        const tz = this.dataset.tz || '+0000';
        const sign = tz[0] === '-' ? -1 : 1;
        const offMin = sign * (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10));
        const now = Date.now();
        const shopNow = new Date(now + offMin * 60000);
        let end = Date.UTC(shopNow.getUTCFullYear(), shopNow.getUTCMonth(), shopNow.getUTCDate(), hh, mm) - offMin * 60000;
        if (end <= now) end += 86400000;
        return end;
      }
      // Schleife: Ende des laufenden Durchlaufs (Start + n * Laenge), danach sofort der naechste.
      // Gerechnet in der Wanduhrzeit des Shops, damit "Montag 00:00" auch nach der Zeitumstellung stimmt.
      loopEnd(now) {
        const m = (this.dataset.loopWall || '').match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})/);
        if (!m) return null;
        const tz = this.dataset.tz || '+0000';
        const sign = tz[0] === '-' ? -1 : 1;
        const off = sign * (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10)) * 60000;
        const wallStart = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
        const wallNow = now + off;
        const period = (parseFloat(this.dataset.loopDays) || 7) * 86400000;
        if (wallNow < wallStart) return null;
        return wallStart + (Math.floor((wallNow - wallStart) / period) + 1) * period - off;
      }
      tick() {
        const now = Date.now();
        if (this.start && now < this.start) { this.hidden = true; return; }
        let end;
        if (this.dataset.mode === 'loop') {
          end = this.loopEnd(now);
          if (end === null) { this.hidden = true; return; }
        } else {
          end = this.dataset.mode === 'daily' ? this.dailyEnd() : parseInt(this.dataset.end, 10) * 1000;
        }
        this.hidden = false;
        const left = Math.max(0, end - now);
        if (left <= 0) return this.expire();
        const s = Math.floor(left / 1000);
        let days = Math.floor(s / 86400);
        let hours = Math.floor((s % 86400) / 3600);
        if (!this.showDays) { hours += days * 24; days = 0; }
        const parts = [];
        if (this.showDays) parts.push([days, this.units[0]]);
        parts.push([hours, this.units[1]], [Math.floor((s % 3600) / 60), this.units[2]]);
        if (this.showSeconds) parts.push([s % 60, this.units[3]]);
        const sep = this.separator ? '<span class="bkcd__sep" aria-hidden="true">:</span>' : '';
        this.timeEl.innerHTML = parts.map(([n, u]) =>
          '<span class="bkcd__unit"><span class="bkcd__num">' + String(n).padStart(2, '0') +
          '</span><span class="bkcd__lbl">' + (u || '') + '</span></span>'
        ).join(sep);
      }
      expire() {
        clearInterval(this.timer);
        if (this.dataset.expired === 'hide') { this.hidden = true; return; }
        ['[data-cd-label]', '[data-cd-time]', '[data-cd-sub]', '[data-cd-btn]'].forEach((q) => {
          const el = this.querySelector(q);
          if (el) el.hidden = true;
        });
        this.doneEl.hidden = false;
      }
    }
    customElements.define('bk-countdown', BkCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-falling-leaves"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bk-falling-leaves')) {
    const SHAPES = {
      maple: 'M50 4 L57 22 L68 14 L66 34 L84 28 L77 44 L94 50 L78 58 L84 72 L64 66 L58 84 L52 72 L52 96 L48 96 L48 72 L42 84 L36 66 L16 72 L22 58 L6 50 L23 44 L16 28 L34 34 L32 14 L43 22 Z',
      oak: 'M50 6 C58 10 60 18 56 24 C66 22 70 30 62 36 C72 36 74 46 64 50 C74 52 74 62 64 64 C70 70 66 78 56 76 C58 84 54 88 51 90 L51 97 L49 97 L49 90 C46 88 42 84 44 76 C34 78 30 70 36 64 C26 62 26 52 36 50 C26 46 28 36 38 36 C30 30 34 22 44 24 C40 18 42 10 50 6 Z',
      round: 'M50 6 C74 22 84 48 70 72 C63 84 55 88 51 90 L51 97 L49 97 L49 90 C45 88 37 84 30 72 C16 48 26 22 50 6 Z'
    };
    const VEINS = 'M50 14 V90 M50 40 L35 30 M50 40 L65 30 M50 58 L37 50 M50 58 L63 50 M50 74 L41 68 M50 74 L59 68';
    const rnd = (a, b) => a + Math.random() * (b - a);

    class BkFallingLeaves extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.onChange = () => this.build();
        this.mq.addEventListener('change', this.onChange);
        this.build();
        // Stop after X seconds: no leaf starts a new round, falling leaves finish and disappear (2026-10-02)
        const stop = this.num('stop', 0);
        if (stop > 0) this.stopTimer = setTimeout(() => this.stop(), stop * 1000);
      }
      stop() {
        this.stopped = true;
        this.querySelectorAll('.bkfl__leaf').forEach((leaf) => {
          leaf.addEventListener('animationiteration', (e) => { if (e.animationName === 'bkfl-fall') leaf.remove(); });
          // leaves whose start is still delayed never appear
          if (parseFloat(leaf.style.getPropertyValue('--dl')) > 0) leaf.remove();
        });
      }
      disconnectedCallback() {
        this.mq.removeEventListener('change', this.onChange);
        clearTimeout(this.stopTimer);
      }
      num(key, fallback) {
        const v = parseFloat(this.dataset[key]);
        return Number.isFinite(v) ? v : fallback;
      }
      build() {
        if (this.stopped) return;
        const d = this.dataset;
        const count = Math.round(this.num(this.mq.matches ? 'countMobile' : 'countDesktop', 0));
        const colors = (d.colors || '#e8751a').split(',').filter(Boolean);
        const shapes = d.shape === 'mix' ? Object.keys(SHAPES) : [d.shape in SHAPES ? d.shape : 'maple'];
        const veins = d.veins === 'true';
        const blur = d.blur === 'true';
        const flutter = d.flutter === 'true';
        const spread = d.spread === 'true';

        const sizeMin = this.num('sizeMin', 18);
        const sizeMax = Math.max(sizeMin, this.num('sizeMax', 38));
        const opMin = this.num('opacityMin', 70) / 100;
        const opMax = Math.max(opMin, this.num('opacityMax', 100) / 100);
        const fallMin = this.num('fallMin', 9);
        const fallMax = Math.max(fallMin, this.num('fallMax', 18));
        const swayMin = this.num('swayMin', 2.5);
        const swayMax = Math.max(swayMin, this.num('swayMax', 5));
        const sway = this.num('sway', 40);
        const spin = this.num('spin', 360);
        const wind = this.num('wind', 30);

        let zones;
        if (d.area === 'full') zones = ['full'];
        else if (d.sides === 'left') zones = ['left'];
        else if (d.sides === 'right') zones = ['right'];
        else zones = ['left', 'right'];

        this.innerHTML = '';
        const els = {};
        zones.forEach((z) => {
          const el = document.createElement('div');
          el.className = 'bkfl__zone bkfl__zone--' + z;
          this.appendChild(el);
          els[z] = el;
        });

        for (let i = 0; i < count; i++) {
          const zone = els[zones[i % zones.length]];
          const size = rnd(sizeMin, sizeMax);
          const fall = rnd(fallMin, fallMax);
          const delay = spread ? -rnd(0, fall) : rnd(0, fall);
          const shape = shapes[Math.floor(Math.random() * shapes.length)];
          const color = colors[Math.floor(Math.random() * colors.length)];
          const leaf = document.createElement('div');
          leaf.className = 'bkfl__leaf';
          leaf.style.cssText = [
            '--s:' + size.toFixed(1) + 'px',
            '--xp:' + Math.random().toFixed(3),
            '--o:' + rnd(opMin, opMax).toFixed(2),
            '--fd:' + fall.toFixed(2) + 's',
            '--dl:' + delay.toFixed(2) + 's',
            '--sd:' + rnd(swayMin, swayMax).toFixed(2) + 's',
            '--sw:' + (sway * rnd(0.5, 1)).toFixed(1) + 'px',
            '--rd:' + fall.toFixed(2) + 's',
            '--rot:' + (spin * rnd(0.5, 1.5) * (Math.random() < 0.5 ? -1 : 1)).toFixed(0) + 'deg',
            '--flip:' + (flutter ? (Math.random() < 0.5 ? 360 : -360) : 0) + 'deg',
            '--wind:' + (wind * rnd(0.6, 1.4)).toFixed(1) + 'px',
            '--c:' + color
          ].join(';');
          if (blur && size < sizeMin + (sizeMax - sizeMin) * 0.35) leaf.style.filter = 'blur(1px)';
          leaf.innerHTML =
            '<div class="bkfl__sway"><div class="bkfl__spin"><svg viewBox="0 0 100 100" focusable="false">' +
            '<path d="' + SHAPES[shape] + '" fill="currentColor"/>' +
            (veins ? '<path d="' + VEINS + '" fill="none" stroke="rgb(0 0 0 / 0.18)" stroke-width="2" stroke-linecap="round"/>' : '') +
            '</svg></div></div>';
          zone.appendChild(leaf);
        }
      }
    }
    customElements.define('bk-falling-leaves', BkFallingLeaves);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-faq-accordion"] && !Shopify.designMode) return;
  try {
    
class BruFaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.oneAtATime = this.dataset.oneAtATime === 'true';
    this.speed = parseInt(this.dataset.animationSpeed, 10) || 300;
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.bk-faq__item');
    this.items.forEach((item) => {
      const btn = item.querySelector('.bk-faq__question');
      if (!btn) return;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle(item);
      });
    });
  }

  toggle(item) {
    const isOpen = item.classList.contains('is-open');
    const btn = item.querySelector('.bk-faq__question');
    const wrapper = item.querySelector('.bk-faq__answer-wrapper');
    if (!wrapper || !btn) return;

    if (isOpen) {
      this.close(item, wrapper, btn);
    } else {
      if (this.oneAtATime) {
        this.closeSiblings(item);
      }
      this.open(item, wrapper, btn);
    }
  }

  open(item, wrapper, btn) {
    item.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');

    wrapper.style.transition = `max-height ${this.speed}ms ease`;
    wrapper.style.maxHeight = wrapper.scrollHeight + 'px';

    const onEnd = () => {
      if (item.classList.contains('is-open')) {
        wrapper.style.maxHeight = 'none';
      }
      wrapper.removeEventListener('transitionend', onEnd);
    };
    wrapper.addEventListener('transitionend', onEnd, { once: true });
    setTimeout(onEnd, this.speed + 50);
  }

  close(item, wrapper, btn) {
    // Lock current pixel height first so transition has something to animate from
    wrapper.style.transition = 'none';
    wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
    // Force reflow
    void wrapper.offsetHeight;

    requestAnimationFrame(() => {
      wrapper.style.transition = `max-height ${this.speed}ms ease`;
      wrapper.style.maxHeight = '0px';
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  closeSiblings(currentItem) {
    const category = currentItem.closest('.bk-faq__category');
    if (!category) return;

    const siblings = category.querySelectorAll('.bk-faq__item.is-open');
    siblings.forEach((sibling) => {
      if (sibling === currentItem) return;
      const wrapper = sibling.querySelector('.bk-faq__answer-wrapper');
      const btn = sibling.querySelector('.bk-faq__question');
      if (wrapper && btn) {
        this.close(sibling, wrapper, btn);
      }
    });
  }
}

customElements.define('bk-faq-accordion', BruFaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-halloween-bat"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bk-halloween-bat')) {
    /* Flug mit Richtung + Tempo statt direkter Positionssprünge: die Fledermaus
       dreht mit begrenzter Drehgeschwindigkeit zum Ziel und ändert ihr Tempo
       weich. So entstehen nur runde Kurven, keine Sprünge. Ziele liegen links
       oder rechts (nie im mittleren Streifen), damit sie über die Mitte nur
       hinwegfliegt; am Rand dreht sie ab und zu eine langsamere Runde. */
    class BkHalloweenBat extends HTMLElement {
      connectedCallback() {
        /* Zeitlimit pro Besuch: gezählt wird nur, solange die Seite sichtbar ist */
        this.limit = this.hasAttribute('data-design') ? 0 : (parseFloat(this.dataset.limit) || 0) * 1000;
        this.shown = this.limit ? this.readShown() : 0;
        if (this.limit && this.shown >= this.limit) {
          this.classList.add('is-done');
          return;
        }
        this.save = () => { if (this.limit) this.writeShown(this.shown); };
        this.onVisibility = () => { if (document.hidden) this.save(); };
        window.addEventListener('pagehide', this.save);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.lastSave = 0;
        const speed = parseFloat(this.dataset.speed) || 2;
        this.baseSpeed = 70 + speed * 45;          /* px pro Sekunde */
        this.pauseMin = (parseFloat(this.dataset.pauseMin) || 0.5) * 1000;
        this.pauseMax = Math.max(this.pauseMin, (parseFloat(this.dataset.pauseMax) || 2) * 1000);
        const w = window.innerWidth, h = window.innerHeight;
        this.size = this.querySelector('.bkbat__bat')?.offsetWidth || 90;
        this.bats = [...this.querySelectorAll('.bkbat__bat')].map((el, i) => {
          const fromLeft = Math.random() < 0.5;
          const bat = {
            el,
            tilt: el.querySelector('.bkbat__tilt'),
            x: fromLeft ? -this.size : w,
            y: 60 + Math.random() * h * 0.4,
            heading: fromLeft ? 0 : Math.PI,
            v: 0, turn: 0, bank: 0,
            tx: 0, ty: 0, targetSince: 0,
            slowUntil: 0, glideUntil: 0,
            depth: Math.random() * Math.PI * 2,
            phase: i * 1.7
          };
          el.style.setProperty('--bkbat-flap', (0.28 + Math.random() * 0.12).toFixed(2) + 's');
          this.newTarget(bat, performance.now());
          return bat;
        });
        this.last = performance.now();
        const tick = (now) => {
          const elapsed = now - this.last;
          const dt = Math.min(0.04, elapsed / 1000);
          this.last = now;
          if (this.limit) {
            this.shown += Math.min(100, elapsed);
            if (now - this.lastSave > 1000) { this.save(); this.lastSave = now; }
            if (!this.leaving && this.shown >= this.limit) this.startLeaving(now);
          }
          this.bats.forEach((bat) => this.step(bat, dt, now));
          if (this.leaving && (this.bats.every((bat) => this.isOut(bat)) || now - this.leaving > 8000)) {
            this.finish();
            return;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.save) {
          this.save();
          window.removeEventListener('pagehide', this.save);
          document.removeEventListener('visibilitychange', this.onVisibility);
        }
      }
      readShown() {
        try { return parseFloat(sessionStorage.getItem('bkbat-shown-ms')) || 0; } catch (e) { return 0; }
      }
      writeShown(ms) {
        try { sessionStorage.setItem('bkbat-shown-ms', String(Math.round(ms))); } catch (e) { /* Speicher gesperrt: Limit gilt dann pro Seite */ }
      }
      /* Zeit abgelaufen: jede Fledermaus fliegt zum nächsten Seitenrand hinaus */
      startLeaving(now) {
        this.leaving = now;
        const w = window.innerWidth;
        this.bats.forEach((bat) => {
          bat.tx = bat.x + this.size / 2 < w / 2 ? -this.size * 3 : w + this.size * 2;
          bat.ty = bat.y - 40;
          bat.slowUntil = 0;
        });
      }
      isOut(bat) {
        const w = window.innerWidth, h = window.innerHeight;
        return bat.x < -this.size * 1.3 || bat.x > w + this.size * 0.3 || bat.y < -this.size || bat.y > h + this.size;
      }
      finish() {
        this.shown = Math.max(this.shown, this.limit);
        this.save();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.classList.add('is-done');
      }
      newTarget(bat, now) {
        const w = window.innerWidth, h = window.innerHeight, size = this.size;
        const cx = bat.x + size / 2;
        /* meist die andere Seite anfliegen, damit sie wirklich herumfliegt */
        const goLeft = Math.random() < 0.4 ? cx > w / 2 : cx <= w / 2;
        const band = w * 0.26;
        const x0 = goLeft ? 0 : w - band;
        bat.tx = x0 + Math.random() * Math.max(0, band - size);
        bat.ty = h * 0.08 + Math.random() * h * 0.62;
        bat.targetSince = now;
      }
      step(bat, dt, now) {
        const w = window.innerWidth;
        const slow = now < bat.slowUntil;
        const vmax = this.baseSpeed * Math.min(1, Math.max(0.6, w / 1000));   /* auf dem Handy etwas langsamer */
        const dx = bat.tx - bat.x, dy = bat.ty - bat.y;
        const dist = Math.hypot(dx, dy);
        if (!this.leaving && !slow && (dist < 70 || now - bat.targetSince > 9000)) {
          /* Ziel erreicht: manchmal eine langsame Runde am Rand drehen, dann weiter */
          if (Math.random() < 0.35) bat.slowUntil = now + this.pauseMin + Math.random() * (this.pauseMax - this.pauseMin);
          this.newTarget(bat, now);
        }
        /* nahe am Bildschirmrand enger zurück ins Bild drehen (weich, kein Anhalten) */
        const nearEdge = !this.leaving && (bat.x < 0 || bat.x > w - this.size || bat.y < 10 || bat.y > window.innerHeight - this.size);
        /* gewünschte Richtung: zum Ziel; bei langsamer Runde einfach weiter kreisen */
        let diff;
        if (slow && !nearEdge) {
          diff = 1.2;
        } else {
          diff = Math.atan2(dy, dx) - bat.heading;
          diff = Math.atan2(Math.sin(diff), Math.cos(diff));
        }
        const maxTurn = nearEdge ? 3.4 : (slow ? 1.6 : 2.2);   /* rad pro Sekunde */
        const wantTurn = Math.max(-maxTurn, Math.min(maxTurn, diff * 2.2));
        bat.turn += (wantTurn - bat.turn) * Math.min(1, 3 * dt);   /* Drehung weich ein-/ausblenden */
        bat.heading += bat.turn * dt;
        /* Tempo weich anpassen: über der Mitte etwas zügiger, in engen Kurven etwas langsamer */
        const cx = (bat.x + this.size / 2) / w;
        const midBoost = !slow && cx > 0.28 && cx < 0.72 ? 1.4 : 1;
        const wantV = vmax * (this.leaving ? 1.3 : (slow ? 0.45 : midBoost)) * (1 - Math.min(0.35, Math.abs(bat.turn) * 0.12));
        bat.v += (wantV - bat.v) * Math.min(1, 1.2 * dt);
        bat.phase += dt * 5;
        bat.x += Math.cos(bat.heading) * bat.v * dt;
        bat.y += (Math.sin(bat.heading) * bat.v + Math.sin(bat.phase) * 12) * dt;
        /* ab und zu gleiten */
        if (!slow && now > bat.glideUntil && Math.random() < dt * 0.12) bat.glideUntil = now + 900 + Math.random() * 900;
        bat.el.classList.toggle('is-gliding', now < bat.glideUntil);
        /* Tiefe: wirkt mal näher, mal weiter weg (langsam) */
        bat.depth += dt * 0.3;
        const scale = 0.88 + (Math.sin(bat.depth) + 1) * 0.11;
        /* in die Kurve legen, weich geglättet */
        const wantBank = Math.max(-24, Math.min(24, bat.turn * 14));
        bat.bank += (wantBank - bat.bank) * Math.min(1, 4 * dt);
        bat.el.style.transform = 'translate3d(' + bat.x.toFixed(1) + 'px,' + bat.y.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
        bat.tilt.style.transform = 'rotate(' + bat.bank.toFixed(1) + 'deg)';
        if (!bat.live) { bat.live = true; bat.el.classList.add('is-live'); }
      }
    }
    customElements.define('bk-halloween-bat', BkHalloweenBat);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-image-buttons"] && !Shopify.designMode) return;
  try {
    
  if (!window.bkibBound) {
    window.bkibBound = true;
    const headerHeight = () => {
      const header = document.querySelector('header-component, #header-component, .header-section, header');
      if (!header) return 0;
      const pos = getComputedStyle(header.closest('.shopify-section') || header).position;
      return pos === 'sticky' || pos === 'fixed' ? header.getBoundingClientRect().height : 0;
    };
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.bkib__btn[data-target]');
      if (!btn) return;
      const el = document.getElementById(btn.dataset.target);
      if (!el) return;
      e.preventDefault();
      const extra = parseInt(btn.closest('.bkib').dataset.offset, 10) || 0;
      const top = el.getBoundingClientRect().top + window.scrollY - headerHeight() - extra;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
      history.replaceState(null, '', '#' + btn.dataset.target);
    });
    const markMissing = (root) => {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      root.querySelectorAll('.bkib__btn').forEach((btn) => {
        const t = btn.dataset.target;
        const missing = t ? !document.getElementById(t) : !btn.hasAttribute('href');
        btn.toggleAttribute('data-missing', missing);
        btn.title = missing ? (t ? 'Kein Ziel mit der ID "' + t + '" auf dieser Seite' : 'Kein Link und keine Anker-ID eingetragen') : '';
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => markMissing(document));
    else markMissing(document);
    document.addEventListener('shopify:section:load', (e) => markMissing(e.target));
    document.addEventListener('shopify:block:select', () => markMissing(document));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.bkpgGalleryBound) {
    window.bkpgGalleryBound = true;
    const update = (track) => {
      const card = track.closest('.bkpg-card');
      if (!card) return;
      /* Ausgeblendete Galerie (z. B. Mobil-Galerie auf Desktop) ueberspringen, sonst wuerde sie die Pfeile sperren */
      if (!track.clientWidth) return;
      const dots = card.querySelectorAll('.bkpg-card__dot');
      if (dots.length && track.clientWidth) {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
      const prev = card.querySelector('[data-bkpg-prev]');
      const next = card.querySelector('[data-bkpg-next]');
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };
    /* Pfeile neu pruefen, sobald die Galerie ihre echte Breite hat. Beim ersten
       Aufruf ist die Breite teils noch 0, dann bliebe der Weiter-Pfeil gesperrt. */
    const ro = 'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((e) => update(e.target))) : null;
    const init = (root) => {
      root.querySelectorAll('[data-bkpg-track]').forEach((track) => {
        if (track.dataset.bkpgReady) return;
        track.dataset.bkpgReady = '1';
        track.addEventListener('scroll', () => update(track), { passive: true });
        if (ro) ro.observe(track);
        update(track);
      });
    };
    window.addEventListener('load', () => document.querySelectorAll('[data-bkpg-track]').forEach(update));
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bkpg-prev], [data-bkpg-next]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const track = btn.closest('.bkpg-card').querySelector('[data-bkpg-track]');
      const dir = btn.hasAttribute('data-bkpg-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }

  /* Laufband: Gruppe bis zur Streifenbreite auffuellen, Dauer = Gruppenbreite / Geschwindigkeit (px/s).
     Laeuft erneut bei Groessenaenderung (auch beim Wechsel Desktop/Mobil, wenn der Streifen erst sichtbar wird). */
  if (!window.bkpgMarqueeBound) {
    window.bkpgMarqueeBound = true;
    const fit = (strip) => {
      const track = strip.querySelector('.bkpg-strip__track');
      if (!track || !strip.clientWidth) return;
      const groups = track.querySelectorAll('.bkpg-strip__group');
      if (groups.length < 2) return;
      const first = groups[0];
      const item = first.firstElementChild;
      let guard = 0;
      while (item && first.getBoundingClientRect().width < strip.clientWidth && guard < 24) {
        first.appendChild(item.cloneNode(true));
        guard += 1;
      }
      if (guard) groups[1].innerHTML = first.innerHTML;
      const speed = parseFloat(strip.dataset.speed) || 40;
      const width = first.getBoundingClientRect().width;
      if (width > 0) strip.style.setProperty('--bkpg-strip-duration', (width / speed).toFixed(2) + 's');
    };
    const ro = 'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((e) => fit(e.target))) : null;
    const initMarquee = (root) => {
      root.querySelectorAll('[data-bkpg-marquee]').forEach((strip) => {
        if (strip.dataset.bkpgMq) return;
        strip.dataset.bkpgMq = '1';
        fit(strip);
        if (ro) ro.observe(strip);
      });
    };
    if (!ro) window.addEventListener('resize', () => document.querySelectorAll('[data-bkpg-marquee]').forEach(fit));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initMarquee(document));
    } else {
      initMarquee(document);
    }
    document.addEventListener('shopify:section:load', (e) => initMarquee(e.target));
  }

  /* Preis-Layout "Gestapelt": Titel und Preisblock je Kartenreihe auf gleiche Hoehe,
     damit Preis, Streichpreis, Spar-Badge und Grundpreis ueber alle Karten auf einer Linie liegen.
     Greift nur, wenn der Preisblock gerade gestapelt ist (flex-direction: column). */
  if (!window.bkpgStackBound) {
    window.bkpgStackBound = true;
    const parts = ['.bkpg-card__title', '.bkpg-card__price'];
    const widths = new WeakMap();
    const align = (grid) => {
      const items = Array.from(grid.children);
      items.forEach((li) => parts.forEach((sel) => {
        const el = li.querySelector(sel);
        if (el) el.style.minHeight = '';
      }));
      const probe = grid.querySelector('.bkpg-card__price');
      const root = grid.closest('.bkpg');
      const split = !!root && root.classList.contains(window.matchMedia('(max-width: 749px)').matches ? 'bkpg--split-m' : 'bkpg--split-d');
      if (!probe || (getComputedStyle(probe).flexDirection !== 'column' && !split)) return;
      const rows = new Map();
      items.forEach((li) => {
        const top = Math.round(li.getBoundingClientRect().top);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(li);
      });
      rows.forEach((row) => {
        if (row.length < 2) return;
        parts.forEach((sel) => {
          const els = row.map((li) => li.querySelector(sel)).filter(Boolean);
          const max = Math.max(...els.map((el) => el.getBoundingClientRect().height));
          els.forEach((el) => { el.style.minHeight = max + 'px'; });
        });
      });
    };
    const ro = 'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((e) => {
      const w = Math.round(e.contentRect.width);
      if (widths.get(e.target) === w) return;
      widths.set(e.target, w);
      align(e.target);
    })) : null;
    const initStack = (root) => {
      root.querySelectorAll('.bkpg--stack-m .bkpg__grid, .bkpg--stack-d .bkpg__grid, .bkpg--split-m .bkpg__grid, .bkpg--split-d .bkpg__grid').forEach((grid) => {
        if (grid.dataset.bkpgStack) return;
        grid.dataset.bkpgStack = '1';
        align(grid);
        if (ro) ro.observe(grid);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => align(grid));
      });
    };
    if (!ro) window.addEventListener('resize', () => document.querySelectorAll('[data-bkpg-stack]').forEach(align));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initStack(document));
    } else {
      initStack(document);
    }
    document.addEventListener('shopify:section:load', (e) => initStack(e.target));
  }

  if (!customElements.get('bkpg-countdown')) {
    class BkpgCountdown extends HTMLElement {
      connectedCallback() {
        this.end = parseInt(this.dataset.end, 10) * 1000;
        this.units = (this.dataset.units || 'Tage,Std.,Min.,Sek.').split(',').map((u) => u.trim());
        this.timeEl = this.querySelector('[data-cd-time]');
        this.doneEl = this.querySelector('[data-cd-done]');
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const left = Math.max(0, this.end - Date.now());
        if (left <= 0) {
          clearInterval(this.timer);
          if (this.dataset.expired === 'hide') { this.hidden = true; return; }
          this.timeEl.hidden = true;
          const label = this.querySelector('.bkpg-countdown__label');
          if (label) label.hidden = true;
          this.doneEl.hidden = false;
          return;
        }
        const s = Math.floor(left / 1000);
        const parts = [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60];
        this.timeEl.innerHTML = parts.map((n, i) =>
          '<span class="bkpg-countdown__unit"><span class="bkpg-countdown__num">' + String(n).padStart(2, '0') +
          '</span><span class="bkpg-countdown__lbl">' + (this.units[i] || '') + '</span></span>'
        ).join('');
      }
    }
    customElements.define('bkpg-countdown', BkpgCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* Find all review sections on the page */
    document.querySelectorAll('[data-section-id]').forEach(function(section) {
      var sectionId = section.getAttribute('data-section-id');
      var track = document.getElementById('custom-reviews-track-' + sectionId);
      var dialog = document.getElementById('custom-reviews-dialog-' + sectionId);
      var dataEl = document.getElementById('custom-reviews-data-' + sectionId);

      if (!track || !dialog || !dataEl) return;

      var reviews = [];
      try {
        reviews = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var currentIndex = 0;
      var starColor = section.getAttribute('data-star-color') || '#f5b400';
      var verifiedColor = section.getAttribute('data-verified-color') || '#4caf50';
      var verifiedText = section.getAttribute('data-verified-text') || 'Verifiziert';

      /* ----- Carousel arrow scrolling ----- */
      var prevBtn = section.querySelector('.custom-reviews__arrow--prev');
      var nextBtn = section.querySelector('.custom-reviews__arrow--next');

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;
      }

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', function() {
          track.scrollBy({ left: -track.offsetWidth * 0.8, behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function() {
          track.scrollBy({ left: track.offsetWidth * 0.8, behavior: 'smooth' });
        });
        track.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      }

      /* ----- Build star HTML for dialog ----- */
      function buildStars(rating) {
        var html = '';
        var r = parseFloat(rating) || 0;
        var full = Math.floor(r);
        var remainder = r - full;
        var hasHalf = remainder >= 0.25 && remainder < 0.75;
        if (remainder >= 0.75) full++;

        for (var i = 1; i <= 5; i++) {
          if (i <= full) {
            html += '<svg width="20" height="20" viewBox="0 0 24 24" fill="' + starColor + '" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
          } else if (hasHalf && i === full + 1) {
            html += '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="half-dlg-' + sectionId + '-' + i + '"><stop offset="50%" stop-color="' + starColor + '"/><stop offset="50%" stop-color="#d0d0d0"/></linearGradient></defs><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#half-dlg-' + sectionId + '-' + i + ')"/></svg>';
            hasHalf = false;
          } else {
            html += '<svg width="20" height="20" viewBox="0 0 24 24" fill="#d0d0d0" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
          }
        }
        return html;
      }

      /* ----- Populate dialog with review data ----- */
      function showReview(index) {
        if (index < 0 || index >= reviews.length) return;
        currentIndex = index;

        var review = reviews[index];
        var imageContainer = document.getElementById('custom-dialog-image-' + sectionId);
        var starsContainer = document.getElementById('custom-dialog-stars-' + sectionId);
        var textEl = document.getElementById('custom-dialog-text-' + sectionId);
        var nameEl = document.getElementById('custom-dialog-name-' + sectionId);
        var dateEl = document.getElementById('custom-dialog-date-' + sectionId);
        var verifiedEl = document.getElementById('custom-dialog-verified-' + sectionId);

        /* Image */
        if (review.image) {
          imageContainer.innerHTML = '<img src="' + review.image + '" alt="Bewertung von ' + (review.name || '') + '" loading="lazy">';
          imageContainer.classList.add('has-image');
        } else {
          imageContainer.innerHTML = '';
          imageContainer.classList.remove('has-image');
        }

        /* Stars */
        starsContainer.innerHTML = buildStars(review.rating);

        /* Text + toggle */
        textEl.textContent = review.text || '';
        textEl.classList.remove('is-expanded');
        textEl.classList.add('custom-reviews__dialog-text--clamped');

        var toggleBtn = document.getElementById('custom-dialog-toggle-' + sectionId);
        if (toggleBtn) {
          toggleBtn.textContent = 'Mehr lesen';
          /* Check after render if text is actually clamped */
          requestAnimationFrame(function() {
            if (textEl.scrollHeight > textEl.clientHeight + 2) {
              toggleBtn.style.display = '';
            } else {
              toggleBtn.style.display = 'none';
            }
          });
        }

        /* Name */
        nameEl.textContent = review.name || '';

        /* Date */
        dateEl.textContent = review.date || '';

        /* Verified */
        if (review.verified) {
          verifiedEl.innerHTML = '<span class="custom-reviews__verified-dot" style="background-color:' + verifiedColor + ';width:8px;height:8px;border-radius:50%;display:inline-block;"></span> ' + verifiedText;
          verifiedEl.style.color = verifiedColor;
          verifiedEl.classList.add('is-visible');
        } else {
          verifiedEl.innerHTML = '';
          verifiedEl.classList.remove('is-visible');
        }

        /* Update prev/next buttons in dialog */
        var prevDialog = dialog.querySelector('.custom-reviews__dialog-prev');
        var nextDialog = dialog.querySelector('.custom-reviews__dialog-next');
        if (prevDialog) prevDialog.disabled = index === 0;
        if (nextDialog) nextDialog.disabled = index === reviews.length - 1;
      }

      /* ----- Card click → open dialog ----- */
      section.querySelectorAll('.custom-reviews__card').forEach(function(card) {
        card.addEventListener('click', function() {
          var idx = parseInt(card.getAttribute('data-review-index'), 10);
          showReview(idx);
          dialog.showModal();
        });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            card.click();
          }
        });
      });

      /* ----- Dialog close ----- */
      dialog.querySelector('.custom-reviews__dialog-close').addEventListener('click', function() {
        dialog.close();
      });

      dialog.addEventListener('click', function(e) {
        if (e.target === dialog) {
          dialog.close();
        }
      });

      dialog.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          dialog.close();
        }
      });

      /* ----- Text toggle (Mehr lesen / Weniger) ----- */
      var toggleBtn = document.getElementById('custom-dialog-toggle-' + sectionId);
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function() {
          var textEl = document.getElementById('custom-dialog-text-' + sectionId);
          if (textEl.classList.contains('is-expanded')) {
            textEl.classList.remove('is-expanded');
            textEl.classList.add('custom-reviews__dialog-text--clamped');
            toggleBtn.textContent = 'Mehr lesen';
          } else {
            textEl.classList.add('is-expanded');
            textEl.classList.remove('custom-reviews__dialog-text--clamped');
            toggleBtn.textContent = 'Weniger';
          }
        });
      }

      /* ----- Dialog prev/next ----- */
      var prevDialog = dialog.querySelector('.custom-reviews__dialog-prev');
      var nextDialog = dialog.querySelector('.custom-reviews__dialog-next');

      if (prevDialog) {
        prevDialog.addEventListener('click', function() {
          if (currentIndex > 0) showReview(currentIndex - 1);
        });
      }
      if (nextDialog) {
        nextDialog.addEventListener('click', function() {
          if (currentIndex < reviews.length - 1) showReview(currentIndex + 1);
        });
      }

      /* Keyboard navigation in dialog */
      dialog.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' && currentIndex > 0) {
          showReview(currentIndex - 1);
        } else if (e.key === 'ArrowRight' && currentIndex < reviews.length - 1) {
          showReview(currentIndex + 1);
        }
      });

      /* ----- Swipe navigation in dialog (mobile) ----- */
      var touchStartX = 0;
      var touchStartY = 0;
      var swiping = false;

      dialog.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });

      dialog.addEventListener('touchend', function(e) {
        if (!swiping) return;
        swiping = false;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        var deltaY = e.changedTouches[0].clientY - touchStartY;
        /* Only trigger if horizontal swipe > 50px and more horizontal than vertical */
        if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
          if (deltaX < 0 && currentIndex < reviews.length - 1) {
            showReview(currentIndex + 1);
          } else if (deltaX > 0 && currentIndex > 0) {
            showReview(currentIndex - 1);
          }
        }
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-sommer-landing"]) return;
  try {
    
(function() {
  // Reveal on scroll ----------------------------------------
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
  document.querySelectorAll('.bk-sommer .reveal').forEach(el => io.observe(el));

  // Smooth-scroll anchors -----------------------------------
  document.querySelectorAll('.bk-sommer a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id.length > 1) {
        const target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // Sticky CTA: hide when bundle section is in view ---------
  const sticky = document.getElementById('bk-sommer-stickyCta');
  const bundle = document.getElementById('bk-sommer-bundle');
  if (sticky && bundle) {
    const stickyIO = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        sticky.style.transform = e.isIntersecting ? 'translateY(120%)' : 'translateY(0)';
      });
    }, { threshold: 0.4 });
    stickyIO.observe(bundle);
    sticky.style.transition = 'transform .25s ease';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
